export const coins_group = [
  'BTC',
  'ETH',
  'USDT',
  'BNB',
  'USDC',
  'XRP',
  'ADA',
  'DOGE',
  'LTC',
  'SOL',
  'TRX',
  'MATIC',
  'DOT',
  'BCH',
  'WBTC',
  'DAI',
  'AVAX',
  'SHIB',
  'BUSD',
  'LINK',
  'ATOM',
  'UNI',
  'XMR',
  'TUSD',
  'XLM',
  'ETC',
  'FIL',
  'ICP',
  'LDO',
  'HBAR',
  'APT',
  'ARB',
  'VET',
  'NEAR',
  'QNT',
  'GRT',
  'AAVE',
  'STX',
  'USDP',
  'MKR',
  'ALGO',
  'EGLD',
  'FTM',
  'OP',
  'SAND',
  'EOS',
  'APE',
  'IMX',
  'XTZ',
  'RNDR',
  'MANA',
  'THETA',
  'FLOW',
  'RPL',
  'AXS',
  'PEPE',
  'INJ',
  'CRV',
  'XEC',
  'NEO',
  'CFX',
  'KAVA',
  'SNX',
  'CHZ',
  'GALA',
  'KLAY',
  'ZEC',
  'IOTA',
  'GMX',
  'LUNC',
  'COMP',
  'FTT',
  'MINA',
  'PAXG',
  'FXS',
  'WOO',
  'DASH',
  'SUI',
  'TWT',
  'RUNE',
  'NEXO',
  'ZIL',
  'CAKE',
  'LRC',
  'CELO',
  'AGIX',
  '1INCH',
  'DYDX',
  'ENJ',
  'GNO',
  'CVX',
  'BAT',
  'MASK',
  'ROSE',
  'QTUM',
  'XEM',
  'RVN',
];
